import { useCallback } from 'react';
import RequestState from '../../../types/RequestState';

/**
 * @param {Object} props
 * @param {Product} props.product
 * @param {Object} props.params
 * @param {string} props.params.activeId
 * @param {string} props.params.state
 */
const useFetchData = ({ product, params }) => {
  const loadShippingDetails = useCallback(() => {
    if (
      !product.shippingStates.get(params.activeId) ||
      product.shippingStates.get(params.activeId) === RequestState.NONE
    ) {
      product.loadShippingDetails(params).catch((e) => console.error(e));
    }
  }, []);

  loadShippingDetails();
};

export default useFetchData;
